<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="board_detail_wrap">
            <div class="bdw_header">
              <div class="bdw_title">
                <h2 v-text="getSurgeryReview.title"></h2>
              </div>
            </div>
            <div class="bdw_content">
              <p v-html="getSurgeryReview.content"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
          <button type="button" class="callTerms" @click="moveList()">목록</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '수술후기',
        prevUrl: '/surgery/surgeryReviewList'
      }
    }
  },
  computed: {
    ...mapGetters('surgery', [
      'getSurgeryReview',
      'getSurgeryReviewList'
    ])
  },
  methods: {
    ...mapActions('surgery', [
      'SURGERY_REVIEW'
    ]),
    moveList () {
      if (sessionStorage.getItem('pathFromLoadUnAuth').indexOf('surgeryReviewList') !== 1) {
        this.$router.push('/surgery/surgeryReviewList')
      } else {
        history.go(-1)
      }
    },
    async fetchData () {
      const code = this.$route.params.code
      try {
        this.SURGERY_REVIEW(code)
      } catch (error) {
        console.log('error :', error);
        console.log('수술후기 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  created () {
    console.log('getSurgeryReviewList', this.getSurgeryReviewList)
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
</style>
